import { Link } from "react-router-dom";
import { CheckIcon, LockClosedIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../../../contexts/LanguageContext";
import { useStore } from "../../../contexts/StoreContext";
import { formatNumber } from "../format";

const PERKS = ["atRisk", "rewards", "staff", "upcoming"];

// Overview card for basic-tier stores: what Insights adds, with the one real
// number the teaser endpoint gives us.
export default function InsightsTeaserCard({ atRisk, previewHref, className = "" }) {
  const { t, language } = useLanguage();
  const { canManageStore } = useStore();

  return (
    <section
      aria-label={t("dashboard.teaserCard.label")}
      className={`flex min-w-0 flex-col gap-4 rounded-[14px] border border-indigo-200 bg-indigo-50 p-6 ${className}`}
    >
      <div className="flex items-center gap-2.5">
        <span className="flex h-9 w-9 items-center justify-center rounded-[10px] bg-white text-indigo-700">
          <LockClosedIcon className="h-5 w-5" aria-hidden="true" />
        </span>
        <span className="rounded-full bg-white px-2.5 py-0.5 text-xs font-semibold text-indigo-800">
          {t("dashboard.teaserCard.badge")}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="text-lg leading-snug font-semibold text-indigo-950">
          {t("dashboard.teaserCard.title")}
        </h2>
        <p className="text-sm leading-relaxed text-indigo-900">
          {Number.isFinite(atRisk) && atRisk > 0
            ? t("dashboard.locked.insights.body", {
                value: formatNumber(atRisk, language),
              })
            : t("dashboard.teaserCard.body")}
        </p>
      </div>
      <ul className="flex flex-col gap-2.5">
        {PERKS.map((perk) => (
          <li key={perk} className="flex items-start gap-2.5 text-sm leading-snug text-indigo-950">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-indigo-700" aria-hidden="true" />
            <span>{t(`dashboard.teaserCard.perks.${perk}`)}</span>
          </li>
        ))}
      </ul>
      <div className="flex flex-wrap items-center gap-2.5">
        {canManageStore && (
          <Link
            to="/pricing"
            className="inline-flex min-h-11 items-center justify-center rounded-[10px] bg-indigo-600 px-5 text-sm font-semibold text-white hover:bg-indigo-700"
          >
            {t("dashboard.locked.insights.upgrade")}
          </Link>
        )}
        <Link
          to={previewHref}
          className="px-1 py-3 text-sm font-medium text-indigo-800 hover:text-indigo-950"
        >
          {t("dashboard.teaserCard.preview")}
        </Link>
      </div>
    </section>
  );
}
